export const TOGGLE_FEEDBACK_FORM = "TOGGLE_FEEDBACK_FORM"

export const toggleFeedbackForm = (payload) => ({
	type: TOGGLE_FEEDBACK_FORM,
	payload
})
